/* eslint-disable react/no-unused-prop-types */
import { useEffect, useMemo, useState } from 'react';
import { arrayOf, shape, string } from 'prop-types';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { t } from '@lingui/macro';

import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropTypes, filterPropDefaults } from '../../page-framework/filter/FilterPropTypes';
import getStatusFilterStateServiceFactory from './StatusFilterStateService';
import StatusBlock from '../../status-block/StatusBlock';
import { orderedStatuses } from '../../../utilities/StatusUtilities';

export const filterTitle = t`Status`;
export const filterId = 'Status';

export const stateType = arrayOf(string);

const DEFAULT_OPTIONS = {
    statuses: _.reverse(orderedStatuses),
};

const useStyles = makeStyles((theme) => ({
    statusBlock: {
        marginRight: theme.spacing(1),
    },
}));

export function StatusFilter({ options, state, filterActions }) {
    const resolvedOptions = useMemo(
        () => ({
            ...DEFAULT_OPTIONS,
            ...options,
        }),
        [options]
    );
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const classes = useStyles();

    useEffect(() => {
        setSelectedStatuses(state || []);
        filterActions.setValid(state?.length > 0);
    }, [state, filterActions]);

    function handleStatusChanged(event, status) {
        let newState;
        if (event.target.checked) {
            newState = [...selectedStatuses, status.value];
        } else {
            newState = _.without(selectedStatuses, status.value);
        }
        setSelectedStatuses(newState);
        filterActions.setState(newState);
    }

    return (
        <FormGroup row={false}>
            {resolvedOptions.statuses.map((status) => (
                <FormControlLabel
                    key={status.value}
                    control={
                        <>
                            <Checkbox
                                checked={_.includes(selectedStatuses, status.value)}
                                onChange={(event) => handleStatusChanged(event, status)}
                            />
                            <StatusBlock className={classes.statusBlock} color={status.color} size={12} />
                        </>
                    }
                    label={status.name}
                />
            ))}
        </FormGroup>
    );
}

StatusFilter.propTypes = {
    id: filterPropTypes.id,
    title: filterPropTypes.title,
    filterActions: filterPropTypes.filterActions,
    state: stateType,
    options: shape({
        statuses: arrayOf(
            shape({
                name: string,
                color: string,
                value: string,
            })
        ),
    }),
};

StatusFilter.defaultProps = {
    ...filterPropDefaults,
    id: filterId,
    title: filterTitle,
    state: undefined,
};

export default Filter({
    filterId,
    filterStateServiceFactory: getStatusFilterStateServiceFactory(filterTitle, 'status'),
})(StatusFilter);
